import { useCallback, useMemo } from 'react'
import { Scale } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchScoringConfig, FRAUD_STR as S, type ScoringRow } from './fraudApi'

/**
 * A25.06 — Настройки скоринга. Per-signal weights and thresholds that feed the
 * risk score. Dormant until `/admin/antifraud/scoring` ships (fail-soft empty).
 * Placeholder permission USERS_VIEW.
 */
export function ScoringConfigScreen() {
  const columns = useMemo<AdminColumn<ScoringRow>[]>(
    () => [
      { key: 'signal', header: S.signal, type: 'text' },
      { key: 'weight', header: S.weight, type: 'number' },
      { key: 'threshold', header: S.threshold, type: 'number' },
      { key: 'enabled', header: S.enabled, type: 'bool' },
    ],
    [],
  )
  const fetcher = useCallback(fetchScoringConfig, [])
  return (
    <>
      <PageHeader title={S.scoring} screenId="A25.06" />
      <DataTable<ScoringRow>
        screenId="A25.06"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => r.id}
        exportable
        emptyState={{ icon: <Scale size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
